var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "off-store-wrap" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "flex-row-between-center title-top" }, [
          _c("div", { staticClass: "flex-row-start-center" }, [
            _c("div", { staticClass: "title-left" }, [
              _vm._v("\n          当前店铺状态：\n          "),
              _c("span", { staticClass: "status-tag" }, [
                _vm._v(_vm._s(_vm.currentStatus))
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStatus == "营业中",
                  expression: "currentStatus == '营业中'"
                }
              ],
              staticClass: "apply-btn",
              on: { click: _vm.applyOffStore }
            },
            [_vm._v("\n        申请休店\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top-img" }, [
          _c("img", {
            attrs: {
              src:
                _vm.currentStatus == "营业中"
                  ? _vm.img.shopOpen
                  : _vm.img.shopClose,
              width: 60,
              alt: ""
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gray-bg" }),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "demo-form-inline",
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            "label-position": "right",
            inline: true,
            model: _vm.searchForm
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "休店原因" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", multiple: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchForm.reason,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "reason", $$v)
                    },
                    expression: "searchForm.reason"
                  }
                },
                _vm._l(_vm.reasonList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", multiple: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchForm.status,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "status", $$v)
                    },
                    expression: "searchForm.status"
                  }
                },
                _vm._l(_vm.statusList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: {
                    background: "#fff",
                    color: "#666",
                    "border-color": "#ccc"
                  },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v("重置\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%", "text-align": "center" },
              attrs: { data: _vm.tableData, size: "mini" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "申请单号", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "content", label: "申请内容", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.rest_type_str) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(scope.row.content))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "reason_str", label: "休店原因", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "detailed_reason", label: "详细原因" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created_at", label: "发起时间", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "review_time", label: "审核时间", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "applicant_name", label: "申请人" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status_str", label: "状态" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "review_comment", label: "审批备注" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticStyle: { "text-align": "center" },
        attrs: {
          "current-page": _vm.queryInfo.current,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.queryInfo.page_size,
          layout: "total,sizes, prev, pager, next,jumper",
          total: _vm.queryInfo.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function($event) {
            return _vm.$set(_vm.queryInfo, "current", $event)
          },
          "update:current-page": function($event) {
            return _vm.$set(_vm.queryInfo, "current", $event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "off-store-dialog",
            title: "申请休店",
            "append-to-body": "",
            center: "",
            visible: _vm.visible,
            width: "660px",
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            close: _vm.hideDialog
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "off-store-form",
              attrs: {
                model: _vm.addForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "休店原因", prop: "reason" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "360px" },
                      attrs: { clearable: "", placeholder: "请选择休店原因" },
                      model: {
                        value: _vm.addForm.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.addForm, "reason", $$v)
                        },
                        expression: "addForm.reason"
                      }
                    },
                    _vm._l(_vm.reasonList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        staticStyle: { width: "360px" },
                        attrs: { value: item.value, label: item.label }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { label: "休店类别", prop: "type" }
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.addForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.addForm, "type", $$v)
                        },
                        expression: "addForm.type"
                      }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { label: "休店", name: "type" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "checked-tips" }, [
                    _c("span", {
                      staticClass: "el-icon-warning-outline c-red"
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(
                        "客户正常下单，商家订单履约时效延长，最长休店时间是15天"
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "详细原因", prop: "detailed_reason" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "360px" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入详细原因，最多不超过20个字",
                      maxlength: "20",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.addForm.detailed_reason,
                      callback: function($$v) {
                        _vm.$set(_vm.addForm, "detailed_reason", $$v)
                      },
                      expression: "addForm.detailed_reason"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "startDay", label: "开始日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "360px" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      pickerOptions: _vm.pickerOptions
                    },
                    model: {
                      value: _vm.addForm.startDay,
                      callback: function($$v) {
                        _vm.$set(_vm.addForm, "startDay", $$v)
                      },
                      expression: "addForm.startDay"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "endDay", label: "结束日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "360px" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      pickerOptions: _vm.pickerOptions2
                    },
                    model: {
                      value: _vm.addForm.endDay,
                      callback: function($$v) {
                        _vm.$set(_vm.addForm, "endDay", $$v)
                      },
                      expression: "addForm.endDay"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.visible = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("addForm")
                        }
                      }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "el-icon-warning c-red" }),
      _vm._v(
        "\n          请注意：商家提交休店申请后，需平台审核通过才生效。平台审核时效：\n          "
      ),
      _c("span", { staticClass: "c-red" }, [_vm._v("1个工作日")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34a0b5fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0b5fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderReport/offStore.vue
// module id = null
// module chunks = 